import { combineReducers } from "redux";
import { api } from "./apiReducer";

const apiReducers = combineReducers({
  api,
});

export default apiReducers;
